export default {
	"name": "shanghai",
	"comment": "Next feature hardfork after the merge hardfork having withdrawals, warm coinbase, push0, limit/meter initcode",
	"url": "https://github.com/ethereum/execution-specs/blob/master/network-upgrades/mainnet-upgrades/shanghai.md",
	"status": "Final",
	"eips": [3651, 3855, 3860, 4895]
}
 ;